export default "{\n    \"pageTitle\": \"New Work Order\",\n    \"heading\": \"Create Work Order\",\n    \"submitButtonLabel\": \"Submit\"\n}\n"